<script setup lang="ts">
import Format from '@/lib/trashsim/format';

const props = withDefaults(defineProps<{
    value?: number | null
    label?: string
    resource: string
    zero?: string
    precision?: number
    color?: boolean
}>(), {
    color: false
})

const isResource = (label: string) => ['metal', 'crystal', 'deuterium', 'food'].includes(label)

const res = () => {
    const isRes = isResource(props.resource)

    let classes: {[key: string]: boolean } = {
        'resource': isRes,
        'fixed': !isRes,
    }
    classes['resource-'+props.resource] = true

    return classes
}

const col = () => {
    return {
        'profit': props.color && ((props.value || 0) > 0),
        'loss': props.color && ((props.value || 0) < 0),
    }
}

</script>

<template>
    <td><div v-bind:class="res()">{{ props.label }}</div></td>
    <td v-bind:class="col()">{{ Format.Number(value || null, props.zero, props.precision) }}</td>
</template>